module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_western_clothing@3x-f039afc9442bdc5dcdeaf79a2f38cec4.webp";